import { render, staticRenderFns } from "./PanelCompetitionCreate.vue?vue&type=template&id=06605d8f&scoped=true&"
import script from "./PanelCompetitionCreate.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionCreate.vue?vue&type=style&index=0&id=06605d8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06605d8f",
  null
  
)

export default component.exports